import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IWorkflowConfigurationsFieldsFragment = {
  id?: any | null
  projectId: any
  maps?: Array<{
    globeViewId?: any | null
    sitemapId?: any | null
    order?: number | null
  } | null> | null
  listColumnsConfig?: Array<{
    columnId: string
    isHidden: boolean
    isFixed: boolean
  } | null> | null
  ganttColumnsConfig?: Array<{
    columnId: string
    isHidden: boolean
    isFixed: boolean
  } | null> | null
}

export type IGetWorkflowsConfigurationsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetWorkflowsConfigurationsQuery = {
  workflowConfigurations?: {
    data: Array<{
      id?: any | null
      projectId: any
      maps?: Array<{
        globeViewId?: any | null
        sitemapId?: any | null
        order?: number | null
      } | null> | null
      listColumnsConfig?: Array<{
        columnId: string
        isHidden: boolean
        isFixed: boolean
      } | null> | null
      ganttColumnsConfig?: Array<{
        columnId: string
        isHidden: boolean
        isFixed: boolean
      } | null> | null
    }>
  } | null
}

export type ISaveWorkflowsConfigurationsMutationVariables = Types.Exact<{
  workflowsConfigurations: Types.IWorkflowConfigurationsInput
}>

export type ISaveWorkflowsConfigurationsMutation = {
  saveWorkflowConfigurations?: {
    id?: any | null
    projectId: any
    maps?: Array<{
      globeViewId?: any | null
      sitemapId?: any | null
      order?: number | null
    } | null> | null
    listColumnsConfig?: Array<{
      columnId: string
      isHidden: boolean
      isFixed: boolean
    } | null> | null
    ganttColumnsConfig?: Array<{
      columnId: string
      isHidden: boolean
      isFixed: boolean
    } | null> | null
  } | null
}

export type IListenToWorkflowsConfigurationsSubscriptionVariables =
  Types.Exact<{
    projectId: Types.Scalars['ObjectId']['input']
  }>

export type IListenToWorkflowsConfigurationsSubscription = {
  workflowConfigurations?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      maps?: Array<{
        globeViewId?: any | null
        sitemapId?: any | null
        order?: number | null
      } | null> | null
      listColumnsConfig?: Array<{
        columnId: string
        isHidden: boolean
        isFixed: boolean
      } | null> | null
      ganttColumnsConfig?: Array<{
        columnId: string
        isHidden: boolean
        isFixed: boolean
      } | null> | null
    } | null
  } | null
}

export const WorkflowConfigurationsFieldsFragmentDoc = gql`
  fragment WorkflowConfigurationsFields on WorkflowConfigurations {
    id
    maps {
      globeViewId
      sitemapId
      order
    }
    listColumnsConfig {
      columnId
      isHidden
      isFixed
    }
    ganttColumnsConfig {
      columnId
      isHidden
      isFixed
    }
    projectId
  }
`
export const GetWorkflowsConfigurationsDocument = gql`
  query GetWorkflowsConfigurations($projectId: ObjectId!) {
    workflowConfigurations(projectId: $projectId, limit: 1) {
      data {
        ...WorkflowConfigurationsFields
      }
    }
  }
  ${WorkflowConfigurationsFieldsFragmentDoc}
`

/**
 * __useGetWorkflowsConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsConfigurationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetWorkflowsConfigurationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetWorkflowsConfigurationsQuery,
    IGetWorkflowsConfigurationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetWorkflowsConfigurationsQuery,
    IGetWorkflowsConfigurationsQueryVariables
  >(GetWorkflowsConfigurationsDocument, options)
}
export function useGetWorkflowsConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetWorkflowsConfigurationsQuery,
    IGetWorkflowsConfigurationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetWorkflowsConfigurationsQuery,
    IGetWorkflowsConfigurationsQueryVariables
  >(GetWorkflowsConfigurationsDocument, options)
}
export type GetWorkflowsConfigurationsQueryHookResult = ReturnType<
  typeof useGetWorkflowsConfigurationsQuery
>
export type GetWorkflowsConfigurationsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowsConfigurationsLazyQuery
>
export type GetWorkflowsConfigurationsQueryResult = Apollo.QueryResult<
  IGetWorkflowsConfigurationsQuery,
  IGetWorkflowsConfigurationsQueryVariables
>
export const SaveWorkflowsConfigurationsDocument = gql`
  mutation SaveWorkflowsConfigurations(
    $workflowsConfigurations: WorkflowConfigurationsInput!
  ) {
    saveWorkflowConfigurations(
      workflowConfigurations: $workflowsConfigurations
    ) {
      ...WorkflowConfigurationsFields
    }
  }
  ${WorkflowConfigurationsFieldsFragmentDoc}
`
export type ISaveWorkflowsConfigurationsMutationFn = Apollo.MutationFunction<
  ISaveWorkflowsConfigurationsMutation,
  ISaveWorkflowsConfigurationsMutationVariables
>

/**
 * __useSaveWorkflowsConfigurationsMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowsConfigurationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowsConfigurationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowsConfigurationsMutation, { data, loading, error }] = useSaveWorkflowsConfigurationsMutation({
 *   variables: {
 *      workflowsConfigurations: // value for 'workflowsConfigurations'
 *   },
 * });
 */
export function useSaveWorkflowsConfigurationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveWorkflowsConfigurationsMutation,
    ISaveWorkflowsConfigurationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveWorkflowsConfigurationsMutation,
    ISaveWorkflowsConfigurationsMutationVariables
  >(SaveWorkflowsConfigurationsDocument, options)
}
export type SaveWorkflowsConfigurationsMutationHookResult = ReturnType<
  typeof useSaveWorkflowsConfigurationsMutation
>
export type SaveWorkflowsConfigurationsMutationResult =
  Apollo.MutationResult<ISaveWorkflowsConfigurationsMutation>
export type SaveWorkflowsConfigurationsMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveWorkflowsConfigurationsMutation,
    ISaveWorkflowsConfigurationsMutationVariables
  >
export const ListenToWorkflowsConfigurationsDocument = gql`
  subscription ListenToWorkflowsConfigurations($projectId: ObjectId!) {
    workflowConfigurations(projectId: $projectId) {
      id
      item {
        ...WorkflowConfigurationsFields
      }
    }
  }
  ${WorkflowConfigurationsFieldsFragmentDoc}
`

/**
 * __useListenToWorkflowsConfigurationsSubscription__
 *
 * To run a query within a React component, call `useListenToWorkflowsConfigurationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToWorkflowsConfigurationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToWorkflowsConfigurationsSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToWorkflowsConfigurationsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToWorkflowsConfigurationsSubscription,
    IListenToWorkflowsConfigurationsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToWorkflowsConfigurationsSubscription,
    IListenToWorkflowsConfigurationsSubscriptionVariables
  >(ListenToWorkflowsConfigurationsDocument, options)
}
export type ListenToWorkflowsConfigurationsSubscriptionHookResult = ReturnType<
  typeof useListenToWorkflowsConfigurationsSubscription
>
export type ListenToWorkflowsConfigurationsSubscriptionResult =
  Apollo.SubscriptionResult<IListenToWorkflowsConfigurationsSubscription>
